import './index.css';

import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { getDataEnvironment } from './dataEnvironment';
import reportWebVitals from './reportWebVitals';

// Components that call axios directly inherit the selected environment from here.
axios.defaults.headers.common['x-data-environment'] = getDataEnvironment();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
